import { ListProgram } from "./list-program";

export class ProgramListViewModel {
    public totalCount: number;
    public programList: ListProgram[];
}



// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/models/common/program-list-viewmodel.ts